import moment from "moment";

const BASE_URL =
  "https://dke7me3t7oathhtjgof2qlm4lq0clobm.lambda-url.us-east-2.on.aws/fdcc-settlements/v1";

const storedToken = localStorage.getItem("token");

const handleAPIRequest = async (url, method, body) => {
  const requestOptions = {
    method: method,
    headers: {
      Authorization: `Bearer ${storedToken}`,
      "Content-Type": "application/json",
    },
  };

  if (body) {
    requestOptions.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    console.log("apiResponse1");
    return response.json();
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
    return null;
  }
};

//Dashboard APIs
export const getNextSettlementsData = async () => {
  console.log("apiResponse2");
  const url = `${BASE_URL}/admin/next/settlements`;
  return handleAPIRequest(url, "GET");
};

export const getWeeklySettlementsData = async (limit) => {
  const url = `${BASE_URL}/admin/weekly/settlements?limit=${limit}`;
  return handleAPIRequest(url, "GET");
};

export const getDriversLeaderBoardSettlementsData = async () => {
  const url = `${BASE_URL}/admin/leaderboard/drivers`;
  return handleAPIRequest(url, "GET");
};

export const getVehiclesLeaderBoardSettlementsData = async () => {
  const url = `${BASE_URL}/admin/leaderboard/vehicles`;
  return handleAPIRequest(url, "GET");
};

export const getDashboardDetailsHeaderKPIData = async (
  finalStartDate,
  finalEndDate
) => {
  // const { startDate, endDate } = convertStartDate(selectedDate);
  const url = `${BASE_URL}/admin/dashboard/kpi?start_date=${finalStartDate}&end_date=${finalEndDate}`;
  return handleAPIRequest(url, "GET");
};
//Add Driver Data
export const addDriverData = async (driverData) => {
  const url = `${BASE_URL}/drivers`;
  return handleAPIRequest(url, "POST", driverData);
};
//Add Vehicle Data
export const addVehicleData = async (VehicleData) => {
  const url = `${BASE_URL}/vehicles`;
  return handleAPIRequest(url, "POST", VehicleData);
};
//Add CSV
//Get Presigned URL for CSV
export const getPresignedURL = async () => {
  const url = `${BASE_URL}/generate/presignedurl`;
  return handleAPIRequest(url, "GET");
};
//Upload CSV
//Submit CSV
export const submitCSV = async (presignedUrlData) => {
  const url = `${BASE_URL}/submit/document`;
  return handleAPIRequest(url, "POST", presignedUrlData);
};

//Drivers Table Data
export const getAllDriversData = async () => {
  const url = `${BASE_URL}/admin/drivers`;
  return handleAPIRequest(url, "GET");
};
export const getDriversHeaderKPIData = async (finalStartDate, finalEndDate) => {
  const url = `${BASE_URL}/admin/driver/kpi?start_date=${finalStartDate}&end_date=${finalEndDate}`;
  return handleAPIRequest(url, "GET");
};

//Driver Details
export const getDriverDetailsHeaderKPIData = async (
  finalStartDate,
  finalEndDate,
  driverId
) => {
  const url = `${BASE_URL}/admin/driver/detail/kpi?start_date=${finalStartDate}&end_date=${finalEndDate}&driver_id=${driverId}`;
  return handleAPIRequest(url, "GET");
};
export const getDriverDetailsProfileData = async (driverId) => {
  const url = `${BASE_URL}/admin/drivers/${driverId}`;
  return handleAPIRequest(url, "GET");
};
export const getDriverDetailsLoadsData = async (driverId) => {
  const url = `${BASE_URL}/admin/drivers/${driverId}/loads`;
  return handleAPIRequest(url, "GET");
};
export const getDriverDetailsSettlementsData = async (driverId) => {
  const url = `${BASE_URL}/admin/drivers/${driverId}/settlements`;
  return handleAPIRequest(url, "GET");
};
export const getDriverSettlementsListData = async (uploadIdDriver) => {
  const url = `${BASE_URL}/admin/settlements/${uploadIdDriver}`;
  return handleAPIRequest(url, "GET");
};
export const getDriverSettelmentDetailsData = async (id, driverId) => {
  const url = `${BASE_URL}/admin/settlements/${id}/${driverId}`;
  return handleAPIRequest(url, "GET");
};

//Vehicle Table Data
export const getAllVehiclesData = async () => {
  const url = `${BASE_URL}/admin/vehicles`;
  return handleAPIRequest(url, "GET");
};
export const getVehiclesHeaderKPIData = async (startDate, endDate) => {
  const url = `${BASE_URL}/admin/driver/kpi?start_date=${startDate}&end_date=${endDate}`;
  return handleAPIRequest(url, "GET");
};

//Vehicle Details
export const getVehicleDetailsHeaderKPIData = async (
  startDate,
  endDate,
  vehicleId
) => {
  const url = `${BASE_URL}/admin/vehicles/kpi?start_date=${startDate}&end_date=${endDate}&vehicle_id=${vehicleId}`;
  return handleAPIRequest(url, "GET");
};
export const getVehicleDetailsProfileData = async (vehicleId) => {
  const url = `${BASE_URL}/admin/vehicle/detail/${vehicleId}`;
  return handleAPIRequest(url, "GET");
};
export const getVehicleDetailsLoadsData = async (vehicleId) => {
  const url = `${BASE_URL}/admin/vehicle/loads/${vehicleId}`;
  return handleAPIRequest(url, "GET");
};

//Loads Details
export const getAllLoadsData = async () => {
  const url = `${BASE_URL}/admin/loads/list`;
  return handleAPIRequest(url, "GET");
};
export const getLoadsHeaderKPIData = async (startDate, endDate) => {
  const url = `${BASE_URL}/admin/loads/kpi?start_date=${startDate}&end_date=${endDate}`;
  return handleAPIRequest(url, "GET");
};

// Settelments Details
export const getSettelmentsDetailsHeaderKPIData = async (uploadId) => {
  const url = `${BASE_URL}/admin/dashboard/kpi?upload_id=${uploadId}`;
  return handleAPIRequest(url, "GET");
};
export const getSettlementsListData = async (uploadId) => {
  const url = `${BASE_URL}/admin/settlements/${uploadId}`;
  return handleAPIRequest(url, "GET");
};
// Settelments Driver Details
export const getSettelmentDriverDetailsData = async (uploadId, id) => {
  const url = `${BASE_URL}/admin/settlements/${uploadId}/${id}`;
  return handleAPIRequest(url, "GET");
};
//Unassign Driver
export const unassignDriver = async (unassignDriverData) => {
  const url = `${BASE_URL}/vehicle_drivers/remove`;
  return handleAPIRequest(url, "POST", unassignDriverData);
};

//Unassign Vehicle
export const unassignVehicle = async (unassignVehicleData) => {
  const url = `${BASE_URL}/vehicle_drivers/remove`;
  return handleAPIRequest(url, "POST", unassignVehicleData);
};

//Assign Driver
export const assignDriver = async (assignDriverData) => {
  const url = `${BASE_URL}/vehicle_drivers/assign`;
  return handleAPIRequest(url, "POST", assignDriverData);
};

//Assign Vehicle
export const assignVehicle = async (assignVehicleData) => {
  const url = `${BASE_URL}/vehicle_drivers/assign`;
  return handleAPIRequest(url, "POST", assignVehicleData);
};

//Update Driver Details
export const updateDriverDetails = async (driverId, updateDriverData) => {
  const url = `${BASE_URL}/drivers/${driverId}`;
  return handleAPIRequest(url, "PUT", updateDriverData);
};

//Update Vehicle Details
export const updateVehicleDetails = async (vehicleId, updateVehicleData) => {
  const url = `${BASE_URL}/vehicles/${vehicleId}`;
  return handleAPIRequest(url, "PUT", updateVehicleData);
};

//Add Other Revenue
export const addOtherRevenue = async (otherRevenueData) => {
  const url = `${BASE_URL}/admin/other-incomes`;
  return handleAPIRequest(url, "POST", otherRevenueData);
};

//Add Deduction
export const addDeduction = async (deductionData) => {
  const url = `${BASE_URL}/admin/deductions`;
  return handleAPIRequest(url, "POST", deductionData);
};

//Delete Other Revenue
export const deleteOtherRevenue = async (index) => {
  const url = `${BASE_URL}/admin/other-incomes/${index}`;
  return handleAPIRequest(url, "DELETE");
};

//Delete Deduction
export const deleteDeduction = async (index) => {
  const url = `${BASE_URL}/admin/deductions/${index}`;
  return handleAPIRequest(url, "DELETE");
};
